class SelectType {
    static NO_SELECT = 0;
    static SINGLE_SELECT = 1;
    static MULTIPLE_SELECT = 2;
}

export default SelectType;